import React from "react";

import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { SundryTemplateModal } from "components/SundryTemplate/Modal";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";

import { useModalAdapter } from "hooks";

interface ParamsReturns {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Form default values from URL params
  formDefaults: any;
}

export function SundryTemplateModalAdapter(
  props: ModalAdapterProps,
): React.JSX.Element {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.SundryTemplate,
    props,
  );

  const { id, ...formDefaults } = hashParams;

  return (
    <WaitForSync requiredData={[]}>
      <SundryTemplateModal
        id={id}
        formDefaults={formDefaults}
        onClose={onClose}
      />
    </WaitForSync>
  );
}
